import { render } from "./basic6Page.vue?vue&type=template&id=ac7d7b26"
import script from "./basic6Page.vue?vue&type=script&lang=js"
export * from "./basic6Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__